import { nextTick } from 'vue'
import { createI18n } from 'vue-i18n'

const supportLocales = ['en', 'de']
export function setupI18n() {
  const i18n = createI18n({
    legacy: false,
    locale: getStartingLocale(),
    fallbackLocale: 'en'
  })
  setI18nLanguage(i18n, getStartingLocale())

  return i18n
}

export function setI18nLanguage(i18n, value) {
  if (i18n.mode === 'legacy') {
    i18n.global.locale = value
  } else {
    i18n.global.locale.value = value
  }
  document.querySelector('html').setAttribute('lang', value)
}

export async function loadLocaleMessages(i18n, locale) {
  // load locale messages with dynamic import
  const messages = await import(
    /* webpackChunkName: "locale-[request]" */ `@/locales/${locale}.json`
  )

  // set locale and locale message
  i18n.setLocaleMessage(locale, messages.default)

  return nextTick()
}

function getBrowserLocale(options = {}) {
  const defaultOptions = { countryCodeOnly: false }

  const opt = { ...defaultOptions, ...options }

  const navigatorLocale =
    navigator.languages !== undefined
      ? navigator.languages[0]
      : navigator.language

  if (!navigatorLocale) {
    return undefined
  }

  return opt.countryCodeOnly
    ? navigatorLocale.trim().split(/-|_/)[0]
    : navigatorLocale.trim()
}

function getStartingLocale() {
  const browserLocale = getBrowserLocale({ countryCodeOnly: true })

  if (supportLocales.includes(browserLocale)) {
    return browserLocale
  } else {
    return 'en'
  }
}
